import { createFileRoute } from "@tanstack/react-router";
import TmsPtsd from "@/pages/TmsPtsd";
export const Route = createFileRoute("/services/ptsd")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "TMS for PTSD | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "PTSD treatment in Coral Springs, FL. Therapy, medication management, and TMS for post-traumatic stress disorder at Neuro Wellness TMS. Free consultation.",
        },
        {
          property: "og:title",
          content: "TMS for PTSD | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "PTSD treatment in Coral Springs, FL. Therapy, medication management, and TMS for post-traumatic stress disorder at Neuro Wellness TMS. Free consultation.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/services/ptsd",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/services/ptsd",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <TmsPtsd />;
}
